export * from "./product-heading";
